module.exports = __webpack_public_path__ + "static/media/cairn.dce0bc7a.jpeg";